module.exports = __webpack_public_path__ + "img/uc_logo.3e52d83f.png";